import React from 'react'
import { connect } from 'react-redux'
import styles from './TRouteComments.scss'
import { CommentsContainer } from 'common/Comments'
import { Msg, commonNouns } from 'lib/localization'

class _TRouteComments extends React.PureComponent {
  render () {
    const { troute, objectType, currentUser } = this.props
    const canModerate = troute.userId === currentUser.id || currentUser.accountLevel === 11
    return (
      <div className={styles.TRouteComments}>
        <h2><Msg capitalized m={commonNouns.comments} values={{ count: 0 }} /></h2>
        <CommentsContainer
          objectType={objectType}
          objectId={troute.get('id')}
          privacyCode={troute.get('privacyCode')}
          includeHeading={false}
          canModerate={canModerate} />
      </div>
    )
  }
}

export const TRouteComments = connect(
  state => ({ currentUser: state.currentUser }),
  null
)(_TRouteComments)
